import type { MusinsaStandardResponse } from '@musinsa/packages-http';
import { z } from 'zod';

// YearMonth: 연도/월 정보
export const YearMonthSchema = z.object({
  year: z.number().int().describe('연도'),
  month: z.number().int().describe('월'),
});

export type YearMonth = z.infer<typeof YearMonthSchema>;

// SalesRankingYearsMonthsResponse: 판매 상품 랭킹 기간 조회 응답
export const SalesRankingYearsMonthsResponseSchema = z.object({
  yearMonths: z.array(YearMonthSchema).describe('조회 가능한 연도/월 목록'),
});

export type GetSalesRankingAvailableYearMonthsResponse = MusinsaStandardResponse<
  z.infer<typeof SalesRankingYearsMonthsResponseSchema>
>;
